/* eslint no-mixed-operators: off */
import React from 'react';
import PropTypes from 'prop-types';
import EventDetailView from './event_detail_view';

const EventDetailContainer = ({ event, market }) => (
  <EventDetailView
    eventDescription={event.description}
    badges={event.metadata ? (event.metadata.badges || []) : []}
    placeTermDescripton={market && market.pltDes || ''}
  />
);

EventDetailContainer.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
  market: PropTypes.instanceOf(Object).isRequired,
};

export default EventDetailContainer;
